"use client";

import Link from "next/link";
import { useState } from "react";
import { ui } from "@/components/ui";
import { authClient } from "@/lib/auth-client";

export function ForgotPasswordForm() {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setPending(true);
    setError(null);
    const { error } = await authClient.requestPasswordReset({
      email: String(form.get("email")),
      redirectTo: "/reset-password",
    });
    setPending(false);
    if (error?.status === 429) setError("Too many requests. Try again later.");
    // Same message whether or not the account exists, to avoid leaking emails.
    else setSent(true);
  }

  if (sent) {
    return (
      <div className={ui.card}>
        <h1 className="text-xl font-semibold">Check your email</h1>
        <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">
          If an account exists for that address, we sent a link to reset the password.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className={`${ui.card} space-y-4`}>
      <h1 className="text-xl font-semibold">Reset password</h1>
      {error && <p className={ui.error} role="alert">{error}</p>}
      <div>
        <label htmlFor="email" className={ui.label}>Email</label>
        <input id="email" name="email" type="email" required autoComplete="email" className={ui.input} />
      </div>
      <button type="submit" disabled={pending} className={`${ui.button} w-full`}>
        {pending ? "Sending…" : "Send reset link"}
      </button>
      <p className="text-center text-sm">
        <Link href="/sign-in" className={ui.link}>Back to sign in</Link>
      </p>
    </form>
  );
}
